import { useEffect } from "react";
import { useNavigate, Link, Outlet } from "react-router-dom";
import { supabase } from "@/services/supabase";

export function AdminLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    // 简单的认证检查
    const isAuthenticated = sessionStorage.getItem("admin_authenticated") === "true";
    if (!isAuthenticated) {
      navigate("/admin/login");
    }
  }, [navigate]);

  const handleLogout = async () => {
    sessionStorage.removeItem("admin_authenticated");
    await supabase.auth.signOut();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/admin/dashboard" className="text-xl font-bold text-gray-900">
              系统管理后台
            </Link>
          </div>
          <button 
            onClick={handleLogout}
            className="text-sm text-gray-500 hover:text-gray-900"
          >
            退出登录
          </button>
        </div>
      </header>
      
      <main className="flex-1 py-8">
        <Outlet />
      </main>
    </div>
  );
}

export function AdminDashboardPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-8">控制面板</h1>
      
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {/* 身份审核卡片 */}
        <div className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow">
          <div className="p-5">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span className="text-4xl">🆔</span>
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    用户管理
                  </dt>
                  <dd>
                    <div className="text-lg font-medium text-gray-900">
                      身份与年龄审核
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-5 py-3">
            <div className="text-sm">
              <Link to="/admin/review" className="font-medium text-blue-600 hover:text-blue-500">
                进入审核系统 &rarr;
              </Link>
            </div>
          </div>
        </div>

        {/* 众筹兑换码卡片 */}
        <div className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow">
          <div className="p-5">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span className="text-4xl">🎁</span>
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    众筹
                  </dt>
                  <dd>
                    <div className="text-lg font-medium text-gray-900">
                      兑换码管理
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-5 py-3">
            <div className="text-sm">
              <Link to="/admin/codes" className="font-medium text-blue-600 hover:text-blue-500">
                生成 / 查询兑换码 &rarr;
              </Link>
            </div>
          </div>
        </div>

        {/* 占位卡片 */}
        <div className="bg-white overflow-hidden shadow rounded-lg opacity-50">
          <div className="p-5">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span className="text-4xl">📊</span>
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    数据统计
                  </dt>
                  <dd>
                    <div className="text-lg font-medium text-gray-900">
                      运营数据大盘
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-5 py-3">
            <div className="text-sm">
              <span className="font-medium text-gray-400">
                开发中...
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}